import React, { useState } from "react";
import PropTypes from "prop-types";
import { remixQuestion } from "../services/surveyService";
import "./RemixQuestion.css";

const RemixQuestion = ({
  surveyId,
  questionId,
  questionType,
  onUpdate,
  onClose,
}) => {
  const [newQuestionText, setNewQuestionText] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");

  const requiresOptions = [
    "Single-choice",
    "Multiple-choice",
    "Checkbox"
  ].includes(questionType);

  const isFormValid = newQuestionText.trim().length >= 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
      setError("Please provide a more detailed prompt (≥ 10 chars).");
      return;
    }
    setLoading(true);
    setError("");
    setStatusMessage("Remix started...");

    try {
      const response = await remixQuestion(surveyId, questionId, newQuestionText);
      if (response.success) {
        onUpdate(response.data); // presumably the updated question
        setStatusMessage("Remix complete!");
        setNewQuestionText("");
      } else {
        throw new Error("Remix API indicated failure.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to remix the question. Please try again."
      );
      setStatusMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* overlay */}
      <div className="modal-overlay" onClick={onClose} />

      <div className="remix-question-container">
        <h4>Remix Question</h4>
        {error && <p className="error-message">Error: {error}</p>}
        {statusMessage && <p className="status-message">{statusMessage}</p>}

        <form onSubmit={handleSubmit}>
          <label htmlFor={`newQuestionText-${questionId}`}>New Question Prompt:</label>
          <textarea
            id={`newQuestionText-${questionId}`}
            value={newQuestionText}
            onChange={(e) => setNewQuestionText(e.target.value)}
            placeholder={`How would you like to remix this ${questionType} question?`}
            required
          />

          <p className="help-text">
            Provide instructions for how you want the question changed (≥ 10 chars).
          </p>

          {requiresOptions && (
            <p className="help-text">
              (FYI: This {questionType} might also need new answer options.)
            </p>
          )}

          <div className="remix-actions">
            <button type="submit" disabled={!isFormValid || loading}>
              {loading ? "Remixing..." : "Remix Question"}
            </button>
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

RemixQuestion.propTypes = {
  surveyId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  questionType: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RemixQuestion;
